/** * Standard colors
 * 
 * Used for InputBox for now..
 */
export enum Color {
  Red = 'hsl(0, 80%, 60%)',
  Green = 'hsl(120, 80%, 60%)',
  Blue = 'hsl(200, 80%, 60%)',
  Black = 'hsl(0, 0%, 10%)',
  White = 'hsl(0, 0%, 80%)',
};